/**
 * All known adunits
 *
 * dyn in the id will allow multiple registrations
 */ import { TEST_REALESTATEID } from './adunits/dealer/DealerAdIframe';
// prettier-ignore
export const ADUNIT_MAP = {
    DesktopDevPageSide300x250Gam: 'desktop-devpage-sidebar-300x250-btf',
    DesktopDevPageSide300x250AtfGam: 'desktop-devpage-sidebar-300x250-atf',
    DesktopDevPageSideVideoSideGam: 'desktop-devpage-video-sidebar-atf',
    DesktopDevPageStage728x90Gam: 'desktop-devpage-artstage-728x90-atf',
    DesktopDevPageArtStageVideo: 'desktop-devpage-artstage-video-atf',
    DesktopComments728x90Gam: 'desktop-devpage-comment-728x90-btf',
    DesktopProfileBottom728x90Gam: 'desktop-profile-gallery-foot-728x90-btf',
    DesktopProfileTop728x90Gam: 'desktop-profile-gallery-top-728x90-btf',
    DesktopProfileVideoGam: 'desktop-profile-video',
    DesktopAdhesionGam: 'desktop-anchor',
    MobileAdhesionGam: 'mobile-anchor',
    AdhesionGam: 'responsive-anchor',
    MobileDevPageVideoStageGam: 'mobile-devpage-video-artstage-atf',
    MobileDevPageSide300x250Gam: 'mobile-devpage-sidebar-300x250-btf',
    MobileGridDynamic300x250Gam: 'mobile-grid-dyn-300x250-btf'
};
export const ADUNIT_IDS = Object.values(ADUNIT_MAP);
// This maps adunit to dealer UUID
export const ADUNIT_FALLBACK_MAP = {
    DesktopDevPageSide300x250Gam: TEST_REALESTATEID,
    DesktopDevPageSide300x250AtfGam: TEST_REALESTATEID,
    DesktopDevPageSideVideoSideGam: TEST_REALESTATEID,
    DesktopDevPageStage728x90Gam: TEST_REALESTATEID,
    DesktopComments728x90Gam: TEST_REALESTATEID,
    DesktopProfileBottom728x90Gam: TEST_REALESTATEID,
    DesktopProfileTop728x90Gam: TEST_REALESTATEID,
    DesktopProfileVideoGam: TEST_REALESTATEID,
    DesktopAdhesionGam: TEST_REALESTATEID,
    MobileAdhesionGam: TEST_REALESTATEID,
    MobileDevPageVideoStageGam: TEST_REALESTATEID,
    MobileDevPageSide300x250Gam: TEST_REALESTATEID,
    MobileGridDynamic300x250Gam: TEST_REALESTATEID,
    DesktopDevPageArtStageVideo: TEST_REALESTATEID
};
export var AdProviders;
(function(AdProviders) {
    AdProviders["Gak"] = 'da';
    AdProviders["Primis"] = 'primis';
    AdProviders["Freestar"] = 'freestar';
})(AdProviders || (AdProviders = {}));
export const ADUNIT_PROVIDER_SAFETY_KEY = {
    [AdProviders.Gak]: 'safety',
    [AdProviders.Primis]: 'safety',
    [AdProviders.Freestar]: 'safety'
};
export function adunitMemo(last, next) {
    return last.safety === next.safety;
}
export const FREESTAR_PREFIX = 'deviantartcom_';
